import React from 'react';

const About = () => {
    return (
        <div className="about">
            <h3 className="about__h3">Hi, I'm Kelly.</h3>
            <p>
                As someone who has always had a passion for technology, it seemed appropriate that I finally turn that interest
                into a career.
            </p>
            <p>
                I began coding in the simplest of ways – MySpace layouts. It was simple, customizing a page that I'd 
                surely cringe at if I were to look back at it, but I found it fun and easy to get lost in. Fast forward
                a few years to the Tumblr times, and I found myself immersing myself in creating personalized themes
                once again. It wasn't until I was older that I realized it was something I could see myself doing for the 
                rest of my life.
            </p>
            <p>
                So unsure of where to turn next, I enrolled in the Road to Hire program at Red Ventures in Charlotte, 
                North Carolina. It gave me an opportunity to grow and to learn, as well as figure out that coding is 
                something I could excel at if I applied myself. My interest quickly fell into front end development as it 
                was something I was familiar and comfortable with and also appealed to the side of me that was interested 
                in design and aesthetics.
            </p>
            <p>
                Through the program I've improved my HTML and CSS abilities per semantics and accessibility, as well as
                learning React to create a more functional, practical webpage and JavaScript to utilize it all. It's an 
                opportunity that I'm eternally grateful for, and I'm excited to see where the future leads me.
            </p>
        </div>
    )
}

export default About;